<div class="profile-container flex-row-container font18 m-10">
    <div class="flex-row-container"  style="background-color:var(--white)">
        <div class="flex-col-container wd-100">
          <div class="flex-row-container p-10 font16 profile-header">
            <span class="flex-1 font18">CLIENT</span>             
          </div>
          <div class="flex-row-container p-10 m-t10">
              <span class="wd-30 ">Name:</span>
              <span class="wd-70">{{primaryClient.clientname | uppercase}}</span>
          </div>
          <div class="flex-row-container p-10 m-t10">
            <span class="wd-30 p-t30">Date of Birth:</span>
            <div>
              <mat-form-field appearance="fill" style="width: 200px">
                <mat-label>Date of Birth</mat-label>
                <input matInput [matDatepicker]="primary"
                      [formControl]="dobPrimary"
                       (dateInput)="dobChangeEvent('input', $event, 'primary')" (dateChange)="dobChangeEvent('change', $event, 'primary')">
                <mat-datepicker-toggle matSuffix [for]="primary"></mat-datepicker-toggle>
                <mat-datepicker #primary></mat-datepicker>
                <mat-hint align="end" style="color:var(--neutralSecondary)">Minimum required age: 18</mat-hint>
              </mat-form-field> (Age: {{primaryClient.age}})             
            </div>
          </div>
          <div class="flex-row-container p-10 m-t10">
            <span class="wd-30">Gender:</span>
            <div class="wd-70">
                <mat-radio-group [(ngModel)]="gender" (change)="selectGender('Primary')">
                    <mat-radio-button value="M">Male</mat-radio-button>
                    <mat-radio-button class="m-l15" value="F">Female</mat-radio-button>
                  </mat-radio-group>
            </div>
          </div>        
          <div class="flex-row-container p-10 m-t10">
              <span class="wd-30 p-t30">State:</span>
              <div class="wd-70">
                  <mat-form-field appearance="fill" style="width: 200px">
                      <mat-label>State</mat-label>
                      <mat-select [(ngModel)]="selectedState" name="state">
                        <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState($event, state.code, 'Primary')">
                          {{state.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field> 
                    <!-- <p> Selected State: {{selectedState}} </p> -->
                    <!-- <mat-form-field appearance="fill">
                      <mat-label>State</mat-label>
                      <mat-select [formControl]="selectedState">
                        <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState()">
                          {{state.value}}
                        </mat-option>
                      </mat-select>
                      
                    </mat-form-field> -->

              </div>
          </div>
          <div class="flex-row-container p-10 m-t10">
            <span class="wd-30 p-t30">Employment Status:</span>
            <div class="wd-70">
                <mat-form-field appearance="fill" style="width: 200px">
                    <mat-label>Employment Status</mat-label>
                    <mat-select [(ngModel)]="selectedEmpType" name="empType">
                      <mat-option *ngFor="let empType of empTypes" [value]="empType.code" (onSelectionChange)="selectEmpType($event, empType.code, 'Primary')">
                        {{empType.value}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field> 
                  <!-- <p> Selected State: {{selectedState}} </p> -->
                  <!-- <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select [formControl]="selectedState">
                      <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState()">
                        {{state.value}}
                      </mat-option>
                    </mat-select>
                    
                  </mat-form-field> -->

            </div>
          </div>
          <div class="flex-row-container p-10 m-t10">
            <span class="wd-30 p-t25">Employment Income:</span>
            <div class="wd-70">
              <mat-form-field style="width: 200px">
                <!-- <span matPrefix>$</span> -->
                <input  
                placeholder="" 
                aria-label="Employment Income" 
                matInput
                style="padding-left: 10px;"
                class="ip-right-align p-r5"
                [formControl]="empIncome">              
              </mat-form-field>
                  
            </div>
          </div>           
        </div>        
    </div>
    <div class="flex-row-container m-l5" style="background-color:var(--white)">
        <div class="flex-col-container wd-100">
          <div class="flex-row-container p-10 font16 profile-header">
            <span class="flex-1 font18">SPOUSE</span> 
            <!-- <a class="pointer"  *ngIf="isSecClSelected" (click)="onChangeClient()">Change Client</a> -->
            <a class="pointer p-l20" style="color: var(--themeSecondaryContrast);"  *ngIf="isSecClSelected" (click)="onRemoveSecClient()">Remove or Change Spouse</a>
          </div>
          <div *ngIf="!isSecClSelected" class="p-10 font16">  
            <mat-form-field style="width:400px;">
              <mat-icon matSuffix>search</mat-icon>
              <input  type="text" 
                placeholder="Client or Account Search" 
                aria-label="Client Search" 
                maxlength="30"
                matInput
                style="padding-left: 10px;"
                [formControl]="searchControl" 
                [matAutocomplete]="auto" 
                *ngIf="clientList">
                <mat-autocomplete #auto="matAutocomplete" [panelWidth]="500" class="client-search-autocomplete">
                      <div class="p-10 search__header B">
                          <span>Clients (</span><span>{{((clientList['@odata.count']>=5)? ('5'):(clientList['@odata.count']))}}</span><span> of {{clientList['@odata.count']}})</span>
                      </div>
                      <mat-option  *ngFor="let c of clientList['value']"  [value]="" (onSelectionChange)="onClientSelectionChange(c)">                          
                      <div style="display: flex; flex-direction: row; justify-content: space-between;" [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                          <div class="search__advisorId-column"> 
                              <span><mat-icon matPrefix [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">person</mat-icon></span>
                          </div>
                          <div class="search__name-column">
                            <span class="text-truncate">{{c.LegalEntityName}}</span>
                            <span style="font-size: 10px;"><span class="B">{{c.Account.length}}</span> Account(s)</span>   
                          </div>
                          <div class="search__name-column">
                            <span class="text-truncate">{{c.ClientAdvisor}}</span>
                            <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                          </div>
                          <div class="search__advisorId-column">
                              <span>{{c.ClientAdvisorID}}</span>
                          </div>
                          <div class="search__amount-column" style="align-items: flex-end;">
                              <span>{{c.ClientKPI && c.ClientKPI.AumTotal | currency }}</span>                             
                            </div>
                        </div>
                      </mat-option> 
                      <div class="p-10 search__header B">
                          <span>Accounts (</span><span>{{((accountList['@odata.count']>=5)? ('5'):(accountList['@odata.count']))}}</span><span> of {{accountList['@odata.count']}})</span>
                      </div>
                      <mat-option  *ngFor="let c of accountList['value']"  [value]="" (onSelectionChange)="onAccountSelectionChange(c)">                          
                        <div style="display: flex; flex-direction: row; justify-content: space-between;" [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                          <div class="advisorId-column"> 
                              <span><mat-icon matPrefix [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">account_balance</mat-icon></span>
                          </div>
                          <div class="search__name-column">
                            <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='INTERNAL'" class="text-truncate">{{(c.gfoCustodyAccount && c.CustodyAccount)?c.CustodyAccount:(c.id | uppercase)}}</span>
                            <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='EXTERNAL'" class="text-truncate">{{c.AccountNickname | uppercase}}</span>                                  
                          </div>
                          <div class="search__name-column">
                            <span class="text-truncate">{{c.ClientAdvisor}}</span>
                            <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                          </div>
                          <div class="search__advisorId-column">
                              <span class="text-truncate">{{c.ClientAdvisorID}}</span>
                          </div>
                          <div class="search__amount-column" style="align-items: flex-end;">
                              <span class="text-truncate">{{c.AccountKPIs && c.AccountKPIs.AccountTotal | currency }}</span>                             
                            </div>
                        </div>
                      </mat-option>                                                 
                </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="isSecClSelected && isBusinessClient">
            <div class="flex-row-container p-10 m-t10 text-red">
                <span class="wd-30 ">Name:</span>
                <span class="wd-70">{{secondaryClient.clientname | uppercase}}</span>                
            </div>
            <div class="flex-row-container p-10 m-t10">
              <span class="red-text m-t2">Business or Trust Client</span>
              <mat-icon class="m-l3 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" [matTooltip]="buinessClientTooltip">info</mat-icon>
              </div>
          </div>
          <div *ngIf="isSecClSelected && !isBusinessClient">
            <div class="flex-row-container p-10 m-t10">
                <span class="wd-30 ">Name:</span>
                <span class="wd-70">{{secondaryClient.clientname | uppercase}}</span>
            </div>
            <div class="flex-row-container p-10 m-t10">
              <span class="wd-30 p-t30">Date of Birth:</span>
              <div>
                <mat-form-field appearance="fill" style="width: 200px">
                  <mat-label>Date of Birth</mat-label>
                  <input matInput [matDatepicker]="secondary"
                        [formControl]="dobSecondary"
                        (dateInput)="dobChangeEvent('input', $event, 'secondary')" (dateChange)="dobChangeEvent('change', $event, 'secondary')">
                  <mat-datepicker-toggle matSuffix [for]="secondary"></mat-datepicker-toggle>
                  <mat-datepicker #secondary></mat-datepicker>
                  <mat-hint align="end" style="color:var(--neutralSecondary)">Minimum required age: 18</mat-hint>
                </mat-form-field> (Age: {{secondaryClient.age}})             
              </div>
            </div>
            <div class="flex-row-container p-10 m-t10">
              <span class="wd-30">Gender:</span>
              <div class="wd-70">
                  <mat-radio-group [(ngModel)]="secGender" (change)="selectGender('Secondary')">
                      <mat-radio-button value="M">Male</mat-radio-button>
                      <mat-radio-button class="m-l15" value="F">Female</mat-radio-button>
                    </mat-radio-group>
              </div>
            </div>        
            <div class="flex-row-container p-10 m-t10">
                <span class="wd-30 p-t30">State:</span>
                <div class="wd-70">
                    <mat-form-field appearance="fill" style="width: 200px">
                        <mat-label>State</mat-label>
                        <mat-select [(ngModel)]="secSelectedState" name="state">
                          <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState($event, state.code, 'Secondary')">
                            {{state.value}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field> 
                      <!-- <p> Selected State: {{selectedState}} </p> -->
                      <!-- <mat-form-field appearance="fill">
                        <mat-label>State</mat-label>
                        <mat-select [formControl]="selectedState">
                          <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState()">
                            {{state.value}}
                          </mat-option>
                        </mat-select>
                        
                      </mat-form-field> -->

                </div>
            </div>
            <div class="flex-row-container p-10 m-t10">
              <span class="wd-30 p-t30">Employment Status:</span>
              <div class="wd-70">
                  <mat-form-field appearance="fill" style="width: 200px">
                      <mat-label>Employment Status</mat-label>
                      <mat-select [(ngModel)]="secSelectedEmpType" name="secEmpType">
                        <mat-option *ngFor="let empType of empTypes" [value]="empType.code" (onSelectionChange)="selectEmpType($event, empType.code, 'Secondary')">
                          {{empType.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field> 
                    <!-- <p> Selected State: {{selectedState}} </p> -->
                    <!-- <mat-form-field appearance="fill">
                      <mat-label>State</mat-label>
                      <mat-select [formControl]="selectedState">
                        <mat-option *ngFor="let state of states" [value]="state.code" (onSelectionChange)="selectState()">
                          {{state.value}}
                        </mat-option>
                      </mat-select>
                      
                    </mat-form-field> -->

              </div>
            </div>
            <div class="flex-row-container p-10 m-t10">
              <span class="wd-30 p-t25">Employment Income:</span>
              <div class="wd-70">
                <mat-form-field style="width: 200px">
                  <!-- <span matPrefix>$</span> -->
                  <input  
                  placeholder="" 
                  aria-label="Employment Income" 
                  matInput
                  style="padding-left: 10px;"
                  class="ip-right-align p-r5"
                  [formControl]="secEmpIncome">              
                </mat-form-field>
                    
              </div>
            </div>            
          </div>
        </div>        
    </div>
</div>  


